import { useState } from "react";
import "../AFCAnalysisTable.css";
export const SupplierTableHeaders = ({onRowClick, onSave, onReset}) => {

const formatDisplayValue = (value) => {
  if (value === null || value === undefined || value === "") return "N/A";
  return String(value).trim() === "-" ? "N/A" : value;
};


const ConsiderFullConfirmationRenderer = (props) => {
  const isConfirmed = props.data?.confirmed === "Yes";
 
  if (isConfirmed) {
    const showReset = Boolean(props.data?.considerFullConfirmationSaved);
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", gap: 8 }}>
        <span style={{ fontStyle: "italic", color: "#6b7280" }}>
          Already confirmed
        </span>
        {showReset && (
          <button
            type="button"
            disabled={!onReset}
            onClick={() => onReset?.(props.data)}
            style={{
              padding: "4px 10px",
              borderRadius: "6px",
              border: "1px solid #94a3b8",
              backgroundColor: "#fff3d6",
              color: "#111827",
              cursor: onReset ? "pointer" : "not-allowed",
            }}
          >
            Reset
          </button>
        )}
      </div>
    );
  }

    const isChecked =
      String(props.data?.considerFullConfirmation || "").toLowerCase() === "yes";
  return (
    <div style={{ display: "flex", alignItems: "center",justifyContent:"center",width:"100%", gap: 8 }}>
      <input
         type="checkbox"
          checked={isChecked}
          onChange={(e) =>
            props?.node?.setDataValue("considerFullConfirmation", e.target.checked ? "Yes" : "No")
          }
      />

      <button
        disabled={!isChecked}
        onClick={() => {
            const forecast = Number(props.data?.totalSupplierForecast || 0);
             props?.node?.setDataValue("considerFullConfirmationSaved", true); 
            props?.node?.setDataValue("totalSupplierConfirmation", forecast);
            props?.node?.setDataValue("variance", 0);
            props?.node?.setDataValue("variancePercent", "0.0%");

            onSave?.(props.data);
          }}
        style={{
          padding: "4px 10px",
          borderRadius: "6px",
          border: "none",
          backgroundColor: isChecked ? "#1976d2" : "#cbd5e1",
          color: "#fff",
          cursor: isChecked ? "pointer" : "not-allowed",
        }}
      >
        Save
      </button>
    </div>
  );
};





    return [
    
        {
            field: "supplierId",
            headerName: "Supplier ID",
            cellClass: "no-focus-border",
            cellRenderer: (params) => (
              formatDisplayValue(params?.value) === "N/A" ? (
                <span>N/A</span>
              ) : (
              <button
                type="button"
                aria-label={`Open supplier ${params?.value}`}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  margin: 0,
                  color: "#1976d2",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onRowClick?.(params?.data);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    e.stopPropagation();
                    onRowClick?.(params?.data);
                  }
                }}
              >
                {formatDisplayValue(params?.value)}
              </button>
              )
            ),
        },
        {
              field:"supplierName",
              headerName:"Supplier Name",
               cellClass: "no-focus-border",
               minWidth: 180,
               valueFormatter: (params) => formatDisplayValue(params?.value),
        },
        
        
        {
            field: "totalSupplierForecast",
            headerName: "Total Supplier Forecast",
             cellClass: "no-focus-border",
             minWidth: 170,
             valueFormatter: (params) => formatDisplayValue(params?.value),
        },
        {
            field: "totalSupplierConfirmation",
            headerName: "Total Supplier Confirmation",
             cellClass: "no-focus-border",
             minWidth: 180,
           valueGetter: (params) =>
        params.data?.confirmed === "No" && !params.data?.considerFullConfirmationSaved
          ? "N/A"
          : params.data?.totalSupplierConfirmation,
    },
         { headerName: "Variance(Confirmation - Forecast)", field: "variance", cellClass: "no-focus-border", minWidth: 200,
            valueGetter: (params) =>
        params.data?.confirmed === "No" && !params.data?.considerFullConfirmationSaved
          ? "N/A"
          : params.data?.variance,
    },
  {
     headerName: "Variance %", 
    field: "variancePercent",  cellClass: "no-focus-border",
   valueGetter: (params) => {
        if (params.data?.confirmed === "No" && !params.data?.considerFullConfirmationSaved) return "N/A";
        return params.data?.variancePercent;
    },
    },
    { headerName: "Confirmed?", field: "confirmed", cellClass: "no-focus-border",minWidth: 140, valueFormatter: (params) => formatDisplayValue(params?.value), },
    { headerName: "Confirmed Date", field: "confirmedDate", cellClass: "no-focus-border",minWidth: 150, valueFormatter: (params) => formatDisplayValue(params?.value), },
 

          {
      field: "considerFullConfirmation",
      headerName: "Consider Full Confirmation",
     cellRenderer: ConsiderFullConfirmationRenderer,
     cellClass: "no-focus-border",
        minWidth: 200,
     cellStyle: { display: "flex", alignItems: "center", justifyContent: "center" },
    },
      
       
    ]
}